module.exports = __webpack_public_path__ + "fonts/Barlow-Regular.e7eb634.ttf";